import { Injectable } from '@angular/core';

import { StringDictionary, isDefined } from '@frontend/sports/common/core/utils/extended-types';

import { BetslipPick } from '../../../../../../core/picks/betslip-pick';
import { BetslipV1Pick } from '../../../../../../core/picks/betslip-v1-pick';
import { BetslipV2OptionMarketPick } from '../../../../../../core/picks/betslip-v2-option-market-pick';
import { BetslipV2ParticipantPick } from '../../../../../../core/picks/betslip-v2-participant-pick';
import { AccaBoostFilter, AccaBoostSportConfig, CriteriaType, IRewardToken } from '../../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../../criteria-validator-base.service';

@Injectable()
export class AccaBoostCompetitionsValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.Competitions;

    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const filter = token.filter as AccaBoostFilter;

        const picks = state.selectedPicks;

        return picks.every((pick) => this.isPickEligible(pick, filter.sportsConfigs));
    }

    private isPickEligible(pick: BetslipPick, sportsConfigs: Record<number, AccaBoostSportConfig>): boolean {
        const leagueId = this.getLeagueId(pick);
        const competitions = sportsConfigs[pick.sportId] && sportsConfigs[pick.sportId].competitions;

        return isDefined(leagueId) && competitions && this.isLeagueEligible(competitions, leagueId);
    }

    private isLeagueEligible(competitions: StringDictionary<number>, leagueId: number): boolean {
        return Object.keys(competitions).length === 0 || isDefined(competitions[leagueId]);
    }

    private getLeagueId(pick: BetslipPick): number | undefined {
        if (BetslipV1Pick.isPick(pick)) {
            return pick.league.parentLeagueId || pick.league.id;
        }

        if (BetslipV2OptionMarketPick.isPick(pick)) {
            return pick.leagueId;
        }

        if (BetslipV2ParticipantPick.isPick(pick)) {
            return pick.leagueId;
        }

        return;
    }
}
